/**
 * Trạng thái hoạt động
 * nddat1 30/01/2023
 */
export default {
  Active: 1,
  InActive: 0
};